<template>
  <div>
    <view-banners></view-banners>
    <section class="section-container-title container-fluid section text-white" style="padding-bottom:0px !important">
      <div class="row">
        <div class="col-md-12 col-lg-12 order-1 mb-5 mb-md-0 ">
          <view-noticias></view-noticias>
        </div>
        <!-- <div class="col-md-4 col-lg-3 order-2 bg-light-2">
          <view-tweets></view-tweets>
        </div> -->
      </div>
    </section>
    <section class="section-container-title container-fluid section text-white">
      <div class="row">
        <div class="col-md-12 ">
          <view-voluntariado></view-voluntariado>
        </div>
      </div>
    </section>
    <!-- <script type="application/javascript" src="assets/vendor/bootstrap/js/popper.js"></script>
    <script type="application/javascript" src="assets/js/other.js"></script>
    <script type="application/javascript" src="assets/js/page.js"></script> -->
  </div>
</template>

<script>
import Swal from "sweetalert2";

import viewBanners from "@/components/home/view-banners";
import viewNoticias from "@/components/home/view-noticias";
import viewTweets from "@/components/home/view-tweets";
import viewVoluntariado from "@/components/home/view-voluntariado";

export default {
  name: "view-home",
  metaInfo: { title: "Transparencia Perú" },

  components: {
    viewBanners,
    viewNoticias,
    viewTweets,
    viewVoluntariado,
  },
  data: () => ({
    popup: {
      activo: "false",
      urlImagen: '',
      urlRedireccion: '',
      tipoPopup: '500px'
    },
  }),
  methods: {
    async fetchPopupConfig() {
      const url = this.apiRoute("Common", "ListParametrosValueByCode");
      try {
        const response = await this.$http.get(url, { params: { Code: "POP" } });
        if (!response.body.error) {
          debugger;
          const params = response.body.data;
          this.popup.activo = params.find(x => x.code == "POPUP_ACTIVO").text ?? "false";
          this.popup.urlImagen = params.find(x => x.code == "POPUP_URL_IMAGEN").text ?? '';
          this.popup.urlRedireccion = params.find(x => x.code == "POPUP_URL_REDIRECCION").text ?? '';
          this.popup.tipoPopup = params.find(x => x.code == "POPUP_TIPOPOPUP").text ?? '';
        }
      } catch (e) {
        // Si falla la carga de config, simplemente no mostramos el popup
      }
    },
    loadPopup() {
      if (this.popup.activo === "false") return;

      const urlImagen = this.popup.urlImagen;
      const urlRedireccion = this.popup.urlRedireccion;
      const tipoPopup = this.popup.tipoPopup == 'ELE' ? '500px' : '70%';
      Swal.fire({
        showConfirmButton: false,
        showCloseButton: false,
        padding: 0,
        background: "transparent",
        width: tipoPopup, //"70%"
        html: `
    <div class="swal-custom-wrapper">
      <button class="swal-btn-close" aria-label="Cerrar">
        ✕
      </button>
      <img
        src="${urlImagen}"
        alt="Popup"
        class="swal-img-clickable"
        style="cursor:pointer;"
      />
    </div>
  `,

        didOpen: () => {
          document
            .querySelector(".swal-btn-close")
            .addEventListener("click", () => Swal.close());

          if (urlRedireccion) {
            document
              .querySelector(".swal-img-clickable")
              .addEventListener("click", () => {
                window.open(urlRedireccion, "_blank");
                Swal.close();
              });
          }
        },
      });
    },
  },

  async mounted() {
    await this.fetchPopupConfig();
    this.loadPopup();
  },
};
</script>
<style>
.swal-custom-wrapper {
  position: relative;
  line-height: 0;
}

.swal-img-clickable {
  display: block;
  width: 100%;
  max-width: 100%;
  border-radius: 12px;
  cursor: pointer;
}

/* BOTÓN CLOSE */
.swal-btn-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
}

.swal-btn-close:hover {
  background: rgba(0, 0, 0, 0.8);
}
</style>